import { render, staticRenderFns } from "./MessageLog.vue?vue&type=template&id=e98abb8a&"
import script from "./MessageLog.vue?vue&type=script&lang=js&"
export * from "./MessageLog.vue?vue&type=script&lang=js&"
import style0 from "./MessageLog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports